import React, {createContext, ReactNode, useCallback, useContext, useState} from 'react';
import Toast, {ToastType} from "./Toast";

interface ToastContextData {
    showMessage: (message: string, type?: ToastType) => void;
}

interface ToastProviderProps {
    children: ReactNode;
}

const ToastContext = createContext<ToastContextData>({} as ToastContextData);

export const useToast = () => useContext(ToastContext);

export function ToastProvider(props: ToastProviderProps) {
    const {children} = props;

    const [message, setMessage] = useState('');
    const [show, setShow] = useState(false);
    const [type, setType] = useState<ToastType>('success');

    const showMessage = useCallback((message: string, type: ToastType = 'success') => {
        setMessage(message);
        setType(type);
        setShow(true);
        setTimeout(() => setShow(false), 4000);
    }, []);

    return (
        <ToastContext.Provider value={{showMessage}}>
            {children}
            <Toast message={message} show={show} setShow={setShow} type={type}/>
        </ToastContext.Provider>
    );
}
